import { HiOutlineDocumentText } from 'react-icons/hi';
import { ReportingControllerBaseConfig } from '../../../base';
import { ContentItemController } from './contentItemInterface';

export function createContentItemController(
    config: Pick<ReportingControllerBaseConfig, 'kernel'>
): ContentItemController {
    const {
        kernel: {
            provider: { createActionController },
        },
    } = config;

    const archiveController = createActionController({
        id: 'archive',
    });

    return {
        useProps(context, item, props) {
            const archive = archiveController.useProps(props.archive);
            return {
                title: item.content.title,
                icon: item.content.icon
                    ? {
                          kind: 'emoji',
                          text: item.content.icon,
                      }
                    : {
                          kind: 'icon',
                          Component: HiOutlineDocumentText,
                      },
                archive,
            };
        },
    };
}
